import { FormatListNumberedRtlIcon } from './FormatListNumberedRtlIcon';

/**
 * author: Google
 * id 8480FB3F-93B8-4445-BE6D-56A47441D6A6
 * name format-list-numbered-rtl
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-numbered-rtl.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListNumberedRightToLeftIcon = FormatListNumberedRtlIcon;
export default FormatListNumberedRightToLeftIcon